import { Configuration } from '@/types';
import ConfigurationTreeView from '@/components/configuration/TreeView.vue';
import { RouteHelpers } from '@/mixins';
import { TreeViewConstants } from '@/types/constants/TreeViewConstants';

const ScriveEditSigningPartyField = () =>
  import(
    /* webpackChunkName: "ScriveEditSigningPartyField" */
    '@/views/configuration/scrive/ScriveEditSigningPartyField.vue'
  );

const ScriveAddSigningPartyField = () =>
  import(
    /* webpackChunkName: "ScriveAddSigningPartyField" */
    '@/views/configuration/scrive/ScriveAddSigningPartyField.vue'
  );

const meta = {
  layout: 'TreeView',
  treePath: 'scrivetemplates',
  treeViewKey: TreeViewConstants.Keys.Configuration,
  title: 'Scrive Templates'
};

const treeView = {
  treeView: ConfigurationTreeView
};

export const SigningPartFieldRoutes = [
  {
    ...Configuration.Scrive.SigningPartyField.Edit,
    components: {
      default: ScriveEditSigningPartyField,
      ...treeView
    },
    meta,
    beforeEnter: (to: any, from: any, next: any) => {
      RouteHelpers.setErrorPageRedirect(Configuration.Scrive.Template.Management.name);
      RouteHelpers.beforeEnterCheckRouteParamAsNumeric(to, from, next, ['documentTypeId', 'templateId', 'signingPartyId', 'id']);
    }
  },
  {
    ...Configuration.Scrive.SigningPartyField.Add,
    components: {
      default: ScriveAddSigningPartyField,
      ...treeView
    },
    meta,
    beforeEnter: (to: any, from: any, next: any) => {
      RouteHelpers.setErrorPageRedirect(Configuration.Scrive.Template.Management.name);
      RouteHelpers.beforeEnterCheckRouteParamAsNumeric(to, from, next, ['documentTypeId', 'templateId', 'signingPartyId']);
    }
  }
];
